import React, { useState } from 'react';
import { 
 
  Typography, 

  Button, 
  Paper, 
  Snackbar,
  Alert,
  Grid
} from '@mui/material';
import { claimBeans } from './api';

const BeanClaim = ({ userEmail, userPhone, isRegistered, onClaimSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleClaimBeans = async (amount, payout) => {
    if (!isRegistered) {
      setError('You must register first to claim beans');
      return;
    }

    try {
      setLoading(true);
      setError(null);

      await claimBeans("Rich.io", amount, payout, userEmail, userPhone);
      
      setSuccess(true);
      onClaimSuccess();
    } catch (err) {
      console.error('Bean claim error:', err);
      setError(err.response?.data?.detail || 'Failed to claim beans. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
      <Typography variant="h5" component="h2" gutterBottom>
        Claim Beans
      </Typography>
      
      <Typography variant="body1" sx={{ mb: 3 }}>
        Claim beans for your purchases:
      </Typography>
      
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Paper 
            elevation={2} 
            sx={{ 
              p: 2, 
              display: 'flex', 
              flexDirection: 'column',
              alignItems: 'center',
              height: '100%'
            }}
          >
            <Typography variant="h6" gutterBottom>
              Coffee Purchase
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              Claim 90 beans for purchasing a cup of coffee
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleClaimBeans(90, 5)}
              disabled={loading || !isRegistered}
              sx={{ mt: 'auto' }}
            >
              {loading ? 'Processing...' : 'Claim 90 Beans'}
            </Button>
            {!isRegistered && (
              <Typography variant="caption" color="error" sx={{ mt: 1 }}>
                Registration required
              </Typography>
            )}
          </Paper>
        </Grid>
        
        <Grid item xs={12} md={6}>
          <Paper 
            elevation={2} 
            sx={{ 
              p: 2, 
              display: 'flex', 
              flexDirection: 'column',
              alignItems: 'center',
              height: '100%'
            }}
          >
            <Typography variant="h6" gutterBottom>
              Coffee Bag Purchase
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              Claim 4000 beans for purchasing a bag of Koffie
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleClaimBeans(4000, 25)}
              disabled={loading || !isRegistered}
              sx={{ mt: 'auto' }}
            >
              {loading ? 'Processing...' : 'Claim 4000 Beans'}
            </Button>
            {!isRegistered && (
              <Typography variant="caption" color="error" sx={{ mt: 1 }}>
                Registration required
              </Typography>
            )}
          </Paper>
        </Grid>
      </Grid>
      
      <Snackbar 
        open={error !== null} 
        autoHideDuration={6000} 
        onClose={() => setError(null)}
      >
        <Alert onClose={() => setError(null)} severity="error" sx={{ width: '100%' }}>
          {error}
        </Alert>
      </Snackbar>
      
      <Snackbar 
        open={success} 
        autoHideDuration={6000} 
        onClose={() => setSuccess(false)}
      >
        <Alert onClose={() => setSuccess(false)} severity="success" sx={{ width: '100%' }}>
          Beans claimed successfully!
        </Alert>
      </Snackbar>
    </Paper>
  );
};

export default BeanClaim;
